import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { useTikTokCampaignsFilter } from './hooks';

export const TikTokCampaignsFilter = () => {
  const { filter, setFilterForm } = useTikTokCampaignsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export * from './hooks';
export * from './schemaTypes';
